import { Module } from 'vuex'
import { Lanterns } from '@/services/lanterns.service'
import { LanternsStoreState } from '@/store/types'
import { Lantern } from '../../../mj-energy-operator/src/models'
import { JsonAPIRestResponse, MapBounds } from '@/types'

export const lanterns: Module<LanternsStoreState, any> = {
  namespaced: true,
  state: {
    loading: false,
    saving: false,
    lanterns: [],
    accidentReasons: [],
    accidentLantern: undefined
  },
  getters: {
    lanterns: (state) => {
      return state.lanterns
    },
    accidentReasons: (state) => {
      return state.accidentReasons
    },
    accidentLantern: (state) => {
      return state.accidentLantern
    }
  },
  mutations: {
    startLoading (state) {
      state.loading = true
    },
    stopLoading (state) {
      state.loading = false
    },
    startSaving (state) {
      state.saving = true
    },
    stopSaving (state) {
      state.saving = false
    },
    setLanterns (state, lanterns) {
      state.lanterns = lanterns
    },
    clearLanterns (state) {
      state.lanterns = []
    },
    setAccidentReasons (state, accidentReasons) {
      state.accidentReasons = accidentReasons
    },
    setAccidentLantern (state, lantern) {
      state.accidentLantern = lantern
    }
  },
  actions: {

    updateLanternStatus ({ commit, state }, lanternId: number) {
      if (state.lanterns.length === 0) {
        return
      }
      const updatedLantern = state.lanterns.find((value, index) => {
        return value.gid === lanternId
      })

      if (updatedLantern) {
        updatedLantern.hasAccident = true
      }
    },

    async loadLanterns ({ commit, state }, bounds?: MapBounds) {
      commit('startLoading')
      // if (state.lanterns.length === 0) {
      const lanterns = (await Lanterns.lanterns(bounds))
        .map((item: JsonAPIRestResponse<Lantern>) => {
          return {
            ...item.attributes,
            id: item.id
          }
        })
      commit('setLanterns', lanterns)
      // }
      commit('stopLoading')
    },

    async loadLantern ({ commit }, pk: string) {
      commit('startLoading')

      const lantern = (await Lanterns.lantern(pk))
      commit('stopLoading')
      commit('setAccidentLantern', {
        ...lantern.attributes,
        id: lantern.id
      })
    },

    async loadAccidentReasons ({ commit }) {
      commit('startLoading')

      const accidentReasons = (await Lanterns.accidentReasons())
        .map((item: JsonAPIRestResponse<Lantern>) => {
          return {
            ...item.attributes,
            id: item.id
          }
        })
      commit('stopLoading')
      commit('setAccidentReasons', accidentReasons)
    },

    async reportLantern ({ commit }, data) {
      commit('startSaving')
      try {
        await Lanterns.reportLantern(data)
      } catch (e) {
        console.log('Error', e)
        throw e.message // for further actions in view
      } finally {
        commit('stopSaving')
      }
    }
  }
}
